import type { ReactNode } from 'react';

import type { LANGUAGE } from '@/types/commonConst';

import { getFeatureMessage } from '..';
import { topicMessages } from './messages';

export type TopicMessageKey = keyof typeof topicMessages;

export const getTopicMessage = (
  lang: LANGUAGE,
  key: TopicMessageKey,
): ReactNode => {
  return getFeatureMessage(topicMessages[key], lang);
};
